import { ApiUtility } from "./ApiUtility";

class ArticlesService {
  getNavigationDetails(articleId: string): any {
    throw new Error("Method not implemented.");
  }
  route = "/posts";
  articleRoute = "/api/articles?lang=";
  articledetsil = "/api/articles/";
  categoryRoute = "/api/settings/filters?lang=";
  faviroute = "/api/articles/";

  getFilters = (productFor: string) => {
    return ApiUtility.get(
      this.categoryRoute +
      localStorage.getItem("lan") +
      "&productFor=" +
      productFor
    );
  };

  getArticles = (
    start: number,
    length: number,
    IsChildLiterature: boolean,
    categoryId: string,
    authorId: string,
    search: string,
    sort: string,
    langId: string,
    isSpecial: boolean
  ) => {
    return ApiUtility.get(
      this.articleRoute +
      localStorage.getItem("lan") +
      "&start=" +
      start +
      "&length=" +
      length +
      "&categoryId=" +
      categoryId +
      "&IsChildLiterature=" +
      IsChildLiterature +
      "&authorId=" +
      authorId +
      "&search=" +
      search +
      "&sort=" +
      sort +
      "&bookLangauge=" +
      langId +
      "&isSpecial=" +
      isSpecial
    );
  };

  // article detail

  getArticlesDetail = (id: string) => {
    return ApiUtility.get(
      this.articledetsil +
      id +
      "?lang=" +
      localStorage.getItem("lan")
    );
  };


  getArticleDetail = (id: string) => {
    const lang = localStorage.getItem("lan") || "hindi";
    return ApiUtility.get(`${this.articledetsil}${id}/SEO?lang=${lang}`);
  };


  addArticlesFavourite = (ArticleId: string) => {
    return ApiUtility.post(this.faviroute + ArticleId + "/favourite", {});
  };

  removeArticlesFaviourite = (ArticleId: string) => {
    return ApiUtility.delete(this.faviroute + ArticleId + "/favourite");
  };

  getarticlesCategory = (lang?: string) => {
    return ApiUtility.get(
      "/api/Articles/Categories?lang=" + lang
    );
  }

  getArticleById = (id: string, userId?: string, lang?: string) => {
    return ApiUtility.get(
      this.articledetsil + id + "?UserId=" + userId + "&lang=" + lang
    );
  }
}
export default new ArticlesService();
